import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';
import { annotateCategoryTreeWithParentTitle, getCategoryListFromResponse } from 'functions/functions';

function Categories() {
  const navigate = useNavigate();

  const [allCategories, setAllCategories] = useState(null)
  const [sortedInfo, setSortedInfo] = useState({});

  const getAllCategories = () => {
    Axios.get("/category")
      .then((res) => {
        const categories = getCategoryListFromResponse(res.data);
        setAllCategories(annotateCategoryTreeWithParentTitle(categories));
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllCategories()
  }, []);

  const clearAll = () => {
    setSortedInfo({});
  };
  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  const deleteDoc = (food) => {
    if (window.confirm(`آیا دسته "${food.title_fa}" حذف گردد؟`)) {
      deleteDocHandler(food);
    }
  };

  const deleteDocHandler = (food) => {
    Axios.delete(`/category/${food.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllCategories()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const goToAddPage = () => {
    navigate("/categories/add")
  }

  const goToSortingPage = () => {
    navigate("/categories/sorting")
  }

  const columns = [
    {
      title: "نام",
      dataIndex: "title_fa",
      key: "title_fa",
      sorter: (a, b) =>
        a.title_fa > b.title_fa ? 1 : b.title_fa > a.title_fa ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "title_fa" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "دسته والد",
      dataIndex: "parent",
      key: "parent",
      render: (_, category) => <span>{category.parentTitleFa || "اصلی"}</span>,
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, food) => (
        <Space size="small">
          <Link
            to={`/categories/edit/${food.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          {/* <Link
            to={`/foods/`}
            className="btn btn-success btn-sm"
          >جزییات</Link> */}
          <button
            onClick={() => deleteDoc(food)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button onClick={goToAddPage}>اضافه کردن</Button>
          <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
          <Button 
            onClick={goToSortingPage}
          >
            مرتب‌سازی و ترتیب‌بندی
          </Button>
        </Space>
        <div>
          {allCategories ?
            allCategories.length > 0 ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={allCategories}
                rowKey="id"
                onChange={handleChange}
              />
              : <h2>محتوایی نیست</h2> : <Loading />}
        </div>
      </div>
    </div>
  );
}
export default Categories
